module.exports = __webpack_public_path__ + "img/b011_2.1c3fcc5e.jpeg";